'use strict';

var cov_13gx1dkt50 = function () {
  var path = 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\views\\views.js',
      hash = 'c5517513305f54e4208beba41bdad6c148786b68',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\app\\views\\views.js',
    statementMap: {
      '0': {
        start: {
          line: 3,
          column: 15
        },
        end: {
          line: 3,
          column: 19
        }
      },
      '1': {
        start: {
          line: 4,
          column: 4
        },
        end: {
          line: 4,
          column: 30
        }
      },
      '2': {
        start: {
          line: 5,
          column: 4
        },
        end: {
          line: 13,
          column: 6
        }
      },
      '3': {
        start: {
          line: 6,
          column: 6
        },
        end: {
          line: 6,
          column: 41
        }
      },
      '4': {
        start: {
          line: 7,
          column: 24
        },
        end: {
          line: 7,
          column: 46
        }
      },
      '5': {
        start: {
          line: 16,
          column: 4
        },
        end: {
          line: 29,
          column: 6
        }
      },
      '6': {
        start: {
          line: 17,
          column: 22
        },
        end: {
          line: 23,
          column: 24
        }
      },
      '7': {
        start: {
          line: 24,
          column: 6
        },
        end: {
          line: 28,
          column: 9
        }
      },
      '8': {
        start: {
          line: 25,
          column: 8
        },
        end: {
          line: 25,
          column: 25
        }
      },
      '9': {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 25
        }
      },
      '10': {
        start: {
          line: 31,
          column: 4
        },
        end: {
          line: 46,
          column: 6
        }
      },
      '11': {
        start: {
          line: 32,
          column: 22
        },
        end: {
          line: 40,
          column: 27
        }
      },
      '12': {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 45,
          column: 9
        }
      },
      '13': {
        start: {
          line: 42,
          column: 8
        },
        end: {
          line: 42,
          column: 24
        }
      },
      '14': {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 25
        }
      },
      '15': {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 52,
          column: 6
        }
      },
      '16': {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 51,
          column: 9
        }
      },
      '17': {
        start: {
          line: 50,
          column: 8
        },
        end: {
          line: 50,
          column: 48
        }
      },
      '18': {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 123,
          column: 6
        }
      },
      '19': {
        start: {
          line: 56,
          column: 22
        },
        end: {
          line: 63,
          column: 24
        }
      },
      '20': {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 122,
          column: 19
        }
      },
      '21': {
        start: {
          line: 65,
          column: 27
        },
        end: {
          line: 71,
          column: 9
        }
      },
      '22': {
        start: {
          line: 72,
          column: 8
        },
        end: {
          line: 74,
          column: 9
        }
      },
      '23': {
        start: {
          line: 73,
          column: 10
        },
        end: {
          line: 73,
          column: 48
        }
      },
      '24': {
        start: {
          line: 75,
          column: 23
        },
        end: {
          line: 78,
          column: 9
        }
      },
      '25': {
        start: {
          line: 79,
          column: 8
        },
        end: {
          line: 121,
          column: 11
        }
      },
      '26': {
        start: {
          line: 80,
          column: 10
        },
        end: {
          line: 120,
          column: 11
        }
      },
      '27': {
        start: {
          line: 81,
          column: 12
        },
        end: {
          line: 85,
          column: 15
        }
      },
      '28': {
        start: {
          line: 87,
          column: 12
        },
        end: {
          line: 91,
          column: 15
        }
      },
      '29': {
        start: {
          line: 92,
          column: 12
        },
        end: {
          line: 119,
          column: 15
        }
      },
      '30': {
        start: {
          line: 99,
          column: 31
        },
        end: {
          line: 99,
          column: 97
        }
      },
      '31': {
        start: {
          line: 100,
          column: 34
        },
        end: {
          line: 100,
          column: 60
        }
      },
      '32': {
        start: {
          line: 102,
          column: 34
        },
        end: {
          line: 102,
          column: 61
        }
      },
      '33': {
        start: {
          line: 103,
          column: 14
        },
        end: {
          line: 118,
          column: 15
        }
      },
      '34': {
        start: {
          line: 104,
          column: 29
        },
        end: {
          line: 104,
          column: 73
        }
      },
      '35': {
        start: {
          line: 105,
          column: 28
        },
        end: {
          line: 105,
          column: 60
        }
      },
      '36': {
        start: {
          line: 107,
          column: 16
        },
        end: {
          line: 107,
          column: 54
        }
      },
      '37': {
        start: {
          line: 108,
          column: 16
        },
        end: {
          line: 108,
          column: 63
        }
      },
      '38': {
        start: {
          line: 110,
          column: 35
        },
        end: {
          line: 114,
          column: 18
        }
      },
      '39': {
        start: {
          line: 115,
          column: 16
        },
        end: {
          line: 115,
          column: 54
        }
      },
      '40': {
        start: {
          line: 117,
          column: 16
        },
        end: {
          line: 117,
          column: 32
        }
      },
      '41': {
        start: {
          line: 126,
          column: 6
        },
        end: {
          line: 126,
          column: 46
        }
      },
      '42': {
        start: {
          line: 127,
          column: 6
        },
        end: {
          line: 129,
          column: 8
        }
      },
      '43': {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 128,
          column: 25
        }
      },
      '44': {
        start: {
          line: 130,
          column: 6
        },
        end: {
          line: 160,
          column: 8
        }
      },
      '45': {
        start: {
          line: 131,
          column: 28
        },
        end: {
          line: 138,
          column: 9
        }
      },
      '46': {
        start: {
          line: 139,
          column: 23
        },
        end: {
          line: 142,
          column: 9
        }
      },
      '47': {
        start: {
          line: 143,
          column: 8
        },
        end: {
          line: 159,
          column: 11
        }
      },
      '48': {
        start: {
          line: 144,
          column: 10
        },
        end: {
          line: 158,
          column: 11
        }
      },
      '49': {
        start: {
          line: 145,
          column: 12
        },
        end: {
          line: 149,
          column: 15
        }
      },
      '50': {
        start: {
          line: 150,
          column: 12
        },
        end: {
          line: 150,
          column: 29
        }
      },
      '51': {
        start: {
          line: 152,
          column: 12
        },
        end: {
          line: 156,
          column: 15
        }
      },
      '52': {
        start: {
          line: 157,
          column: 12
        },
        end: {
          line: 157,
          column: 29
        }
      },
      '53': {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 184,
          column: 6
        }
      },
      '54': {
        start: {
          line: 164,
          column: 6
        },
        end: {
          line: 178,
          column: 13
        }
      },
      '55': {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 183,
          column: 9
        }
      },
      '56': {
        start: {
          line: 180,
          column: 8
        },
        end: {
          line: 180,
          column: 48
        }
      },
      '57': {
        start: {
          line: 182,
          column: 8
        },
        end: {
          line: 182,
          column: 61
        }
      },
      '58': {
        start: {
          line: 188,
          column: 0
        },
        end: {
          line: 196,
          column: 5
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 119
          },
          end: {
            line: 185,
            column: 3
          }
        },
        line: 2
      },
      '1': {
        name: '(anonymous_1)',
        decl: {
          start: {
            line: 5,
            column: 19
          },
          end: {
            line: 5,
            column: 20
          }
        },
        loc: {
          start: {
            line: 5,
            column: 31
          },
          end: {
            line: 13,
            column: 5
          }
        },
        line: 5
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 16,
            column: 24
          },
          end: {
            line: 16,
            column: 25
          }
        },
        loc: {
          start: {
            line: 16,
            column: 38
          },
          end: {
            line: 29,
            column: 5
          }
        },
        line: 16
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 24,
            column: 35
          },
          end: {
            line: 24,
            column: 36
          }
        },
        loc: {
          start: {
            line: 24,
            column: 41
          },
          end: {
            line: 26,
            column: 7
          }
        },
        line: 24
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 26,
            column: 10
          }
        },
        loc: {
          start: {
            line: 26,
            column: 15
          },
          end: {
            line: 28,
            column: 7
          }
        },
        line: 26
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 31,
            column: 22
          },
          end: {
            line: 31,
            column: 23
          }
        },
        loc: {
          start: {
            line: 31,
            column: 36
          },
          end: {
            line: 46,
            column: 5
          }
        },
        line: 31
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 41,
            column: 35
          },
          end: {
            line: 41,
            column: 36
          }
        },
        loc: {
          start: {
            line: 41,
            column: 41
          },
          end: {
            line: 43,
            column: 7
          }
        },
        line: 41
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 43,
            column: 9
          },
          end: {
            line: 43,
            column: 10
          }
        },
        loc: {
          start: {
            line: 43,
            column: 15
          },
          end: {
            line: 45,
            column: 7
          }
        },
        line: 43
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 48,
            column: 20
          },
          end: {
            line: 48,
            column: 21
          }
        },
        loc: {
          start: {
            line: 48,
            column: 32
          },
          end: {
            line: 52,
            column: 5
          }
        },
        line: 48
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 49,
            column: 53
          },
          end: {
            line: 49,
            column: 54
          }
        },
        loc: {
          start: {
            line: 49,
            column: 64
          },
          end: {
            line: 51,
            column: 7
          }
        },
        line: 49
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 55,
            column: 21
          },
          end: {
            line: 55,
            column: 22
          }
        },
        loc: {
          start: {
            line: 55,
            column: 35
          },
          end: {
            line: 123,
            column: 5
          }
        },
        line: 55
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 64,
            column: 35
          },
          end: {
            line: 64,
            column: 36
          }
        },
        loc: {
          start: {
            line: 64,
            column: 41
          },
          end: {
            line: 122,
            column: 7
          }
        },
        line: 64
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 79,
            column: 65
          },
          end: {
            line: 79,
            column: 66
          }
        },
        loc: {
          start: {
            line: 79,
            column: 75
          },
          end: {
            line: 121,
            column: 9
          }
        },
        line: 79
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 96,
            column: 20
          },
          end: {
            line: 96,
            column: 21
          }
        },
        loc: {
          start: {
            line: 96,
            column: 30
          },
          end: {
            line: 119,
            column: 13
          }
        },
        line: 96
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 122,
            column: 9
          },
          end: {
            line: 122,
            column: 10
          }
        },
        loc: {
          start: {
            line: 122,
            column: 15
          },
          end: {
            line: 122,
            column: 17
          }
        },
        line: 122
      },
      '15': {
        name: 'GiftController',
        decl: {
          start: {
            line: 125,
            column: 13
          },
          end: {
            line: 125,
            column: 27
          }
        },
        loc: {
          start: {
            line: 125,
            column: 65
          },
          end: {
            line: 161,
            column: 5
          }
        },
        line: 125
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 127,
            column: 27
          },
          end: {
            line: 127,
            column: 28
          }
        },
        loc: {
          start: {
            line: 127,
            column: 39
          },
          end: {
            line: 129,
            column: 7
          }
        },
        line: 127
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 130,
            column: 20
          },
          end: {
            line: 130,
            column: 21
          }
        },
        loc: {
          start: {
            line: 130,
            column: 32
          },
          end: {
            line: 160,
            column: 7
          }
        },
        line: 130
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 143,
            column: 66
          },
          end: {
            line: 143,
            column: 67
          }
        },
        loc: {
          start: {
            line: 143,
            column: 76
          },
          end: {
            line: 159,
            column: 9
          }
        },
        line: 143
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 163,
            column: 24
          },
          end: {
            line: 163,
            column: 25
          }
        },
        loc: {
          start: {
            line: 163,
            column: 38
          },
          end: {
            line: 184,
            column: 5
          }
        },
        line: 163
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 176,
            column: 16
          },
          end: {
            line: 176,
            column: 17
          }
        },
        loc: {
          start: {
            line: 176,
            column: 22
          },
          end: {
            line: 177,
            column: 11
          }
        },
        line: 176
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 177,
            column: 13
          },
          end: {
            line: 177,
            column: 14
          }
        },
        loc: {
          start: {
            line: 177,
            column: 19
          },
          end: {
            line: 178,
            column: 11
          }
        },
        line: 177
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 179,
            column: 20
          },
          end: {
            line: 179,
            column: 21
          }
        },
        loc: {
          start: {
            line: 179,
            column: 26
          },
          end: {
            line: 181,
            column: 7
          }
        },
        line: 179
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 181,
            column: 9
          },
          end: {
            line: 181,
            column: 10
          }
        },
        loc: {
          start: {
            line: 181,
            column: 28
          },
          end: {
            line: 183,
            column: 7
          }
        },
        line: 181
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 74,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 74,
            column: 9
          }
        }, {
          start: {
            line: 72,
            column: 8
          },
          end: {
            line: 74,
            column: 9
          }
        }],
        line: 72
      },
      '1': {
        loc: {
          start: {
            line: 80,
            column: 10
          },
          end: {
            line: 120,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 80,
            column: 10
          },
          end: {
            line: 120,
            column: 11
          }
        }, {
          start: {
            line: 80,
            column: 10
          },
          end: {
            line: 120,
            column: 11
          }
        }],
        line: 80
      },
      '2': {
        loc: {
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 158,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 158,
            column: 11
          }
        }, {
          start: {
            line: 144,
            column: 10
          },
          end: {
            line: 158,
            column: 11
          }
        }],
        line: 144
      },
      '3': {
        loc: {
          start: {
            line: 180,
            column: 15
          },
          end: {
            line: 180,
            column: 47
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 180,
            column: 15
          },
          end: {
            line: 180,
            column: 29
          }
        }, {
          start: {
            line: 180,
            column: 33
          },
          end: {
            line: 180,
            column: 47
          }
        }],
        line: 180
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewsController = function ViewsController($scope, $http, $rootScope, $state, myVars, $mdDialog, ngNotify, $location, PageViews, $mdMedia, $window) {
  _classCallCheck(this, ViewsController);

  ++cov_13gx1dkt50.f[0];

  var self = (++cov_13gx1dkt50.s[0], this);
  ++cov_13gx1dkt50.s[1];
  $scope.checkinfo = myVars;
  ++cov_13gx1dkt50.s[2];
  this.$onInit = function () {
    ++cov_13gx1dkt50.f[1];
    ++cov_13gx1dkt50.s[3];

    self.myScopeObject = self.clipData;
    var viewcount = (++cov_13gx1dkt50.s[4], PageViews.get('views'));
    // if (viewcount > 3 && self.myScopeObject.isbuy === false && (myVars.checkMember === '1' || myVars.checkMember === null) && myVars.msisdn === null) {
    //   $scope.dangkywifi();
    // } else if (viewcount > 3 && self.myScopeObject.isbuy === false && (myVars.checkMember === '1' || myVars.checkMember === null) && myVars.msisdn !== null) {
    //   $scope.dangky3g();
    // }
  };

  // $scope.checkinfo = myVars;
  ++cov_13gx1dkt50.s[5];
  $scope.dangkywifi = function (ev) {
    ++cov_13gx1dkt50.f[2];

    var confirm = (++cov_13gx1dkt50.s[6], $mdDialog.confirm().title('Bạn có muốn tiếp tục xem thêm clip ?').textContent('Quý khách đã hết lượt xem miễn phí trong ngày. Soạn DK gửi 9319 để tiếp tục sử dụng dịch vụ').clickOutsideToClose(false).escapeToClose(false).ok('Quay lại').targetEvent(ev));
    ++cov_13gx1dkt50.s[7];
    $mdDialog.show(confirm).then(function () {
      ++cov_13gx1dkt50.f[3];
      ++cov_13gx1dkt50.s[8];

      $state.go('app');
    }, function () {
      ++cov_13gx1dkt50.f[4];
      ++cov_13gx1dkt50.s[9];

      $mdDialog.show();
    });
  };

  ++cov_13gx1dkt50.s[10];
  $scope.dangky3g = function (ev) {
    ++cov_13gx1dkt50.f[5];

    var confirm = (++cov_13gx1dkt50.s[11], $mdDialog.confirm().title('Đăng ký dịch vụ').textContent('Quý khách đã hết lượt xem miễn phí trong ngày, click ĐỒNG Ý để đăng ký dịch vụ ').ariaLabel('Lucky day').targetEvent(ev).clickOutsideToClose(false).escapeToClose(false).ok('ĐỒNG Ý').cancel('QUAY LẠI'));
    ++cov_13gx1dkt50.s[12];
    $mdDialog.show(confirm).then(function () {
      ++cov_13gx1dkt50.f[6];
      ++cov_13gx1dkt50.s[13];

      $scope.dangky();
    }, function () {
      ++cov_13gx1dkt50.f[7];
      ++cov_13gx1dkt50.s[14];

      $state.go('app');
    });
  };

  ++cov_13gx1dkt50.s[15];
  $scope.dangky = function () {
    ++cov_13gx1dkt50.f[8];
    ++cov_13gx1dkt50.s[16];

    $http.post($rootScope.apiOpen + 'dangky').then(function (results) {
      ++cov_13gx1dkt50.f[9];
      ++cov_13gx1dkt50.s[17];

      $window.location = results.data.message;
    });
  };

  // alert(PageViews.get('views'));
  ++cov_13gx1dkt50.s[18];
  $scope.showBuy = function (ev) {
    ++cov_13gx1dkt50.f[10];

    var confirm = (++cov_13gx1dkt50.s[19], $mdDialog.confirm().title('Bạn có muốn mua clip  (1.000 đ/lần)').textContent('Tên clip : ' + self.myScopeObject.title).ariaLabel('Lucky day').targetEvent(ev).clickOutsideToClose(true).ok('Đồng ý !').cancel('Không'));
    ++cov_13gx1dkt50.s[20];
    $mdDialog.show(confirm).then(function () {
      ++cov_13gx1dkt50.f[11];

      var contentBuy = (++cov_13gx1dkt50.s[21], {
        msisdn: myVars.msisdn,
        clip: self.myScopeObject.title,
        link: $location.absUrl(),
        id: self.myScopeObject.id,
        status: true
      });
      ++cov_13gx1dkt50.s[22];
      if ($scope.receiver) {
        ++cov_13gx1dkt50.b[0][0];
        ++cov_13gx1dkt50.s[23];

        contentBuy.receiver = $scope.receiver;
      } else {
        ++cov_13gx1dkt50.b[0][1];
      }
      var config = (++cov_13gx1dkt50.s[24], {
        params: contentBuy,
        headers: { Accept: 'application/json' }
      });
      ++cov_13gx1dkt50.s[25];
      $http.get($rootScope.apiOpen + 'clips/buy', config).then(function (result) {
        ++cov_13gx1dkt50.f[12];
        ++cov_13gx1dkt50.s[26];

        if (result.data.status !== '0') {
          ++cov_13gx1dkt50.b[1][0];
          ++cov_13gx1dkt50.s[27];

          ngNotify.set('Có lỗi xảy ra , xin vui lòng thử lại sau !', {
            position: 'top',
            type: 'error',
            duration: 3000
          });
        } else {
          ++cov_13gx1dkt50.b[1][1];
          ++cov_13gx1dkt50.s[28];

          ngNotify.set('Bạn đã tải clip thành công', {
            position: 'top',
            type: 'success',
            duration: 3000
          });
          ++cov_13gx1dkt50.s[29];
          $http({
            method: 'GET',
            url: $rootScope.apiOpen + 'clips/download/' + self.myScopeObject.id,
            responseType: 'arraybuffer'
          }).then(function (result) {
            ++cov_13gx1dkt50.f[13];

            //  result.headers = headers();

            var filename = (++cov_13gx1dkt50.s[30], self.myScopeObject.extendlink.replace(/\\$/, '').split('\\').pop());
            var contentType = (++cov_13gx1dkt50.s[31], 'application/octet-stream');

            var linkElement = (++cov_13gx1dkt50.s[32], document.createElement('a'));
            ++cov_13gx1dkt50.s[33];
            try {
              var blob = (++cov_13gx1dkt50.s[34], new Blob([result.data], { type: contentType }));
              var url = (++cov_13gx1dkt50.s[35], window.URL.createObjectURL(blob));

              ++cov_13gx1dkt50.s[36];
              linkElement.setAttribute('href', url);
              ++cov_13gx1dkt50.s[37];
              linkElement.setAttribute('download', filename);

              var clickEvent = (++cov_13gx1dkt50.s[38], new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: false
              }));
              ++cov_13gx1dkt50.s[39];
              linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
              ++cov_13gx1dkt50.s[40];

              console.log(ex);
            }
          });
        }
      });
    }, function () {
      ++cov_13gx1dkt50.f[14];
    });
  };

  function GiftController($scope, $mdDialog, msisdn, receiver) {
    ++cov_13gx1dkt50.f[15];
    ++cov_13gx1dkt50.s[41];

    $scope.title = self.myScopeObject.title;
    ++cov_13gx1dkt50.s[42];
    $scope.closeDialog = function () {
      ++cov_13gx1dkt50.f[16];
      ++cov_13gx1dkt50.s[43];

      $mdDialog.hide();
    };
    ++cov_13gx1dkt50.s[44];
    $scope.gift = function () {
      ++cov_13gx1dkt50.f[17];

      var contentGift = (++cov_13gx1dkt50.s[45], {
        msisdn: myVars.msisdn,
        receiver: $scope.receiver,
        clip: self.myScopeObject.title,
        id: self.myScopeObject.id,
        link: $location.absUrl(),
        status: true
      });
      var config = (++cov_13gx1dkt50.s[46], {
        params: contentGift,
        headers: { Accept: 'application/json' }
      });
      ++cov_13gx1dkt50.s[47];
      $http.get($rootScope.apiOpen + 'clips/gift', config).then(function (result) {
        ++cov_13gx1dkt50.f[18];
        ++cov_13gx1dkt50.s[48];

        if (result.data.status !== '0') {
          ++cov_13gx1dkt50.b[2][0];
          ++cov_13gx1dkt50.s[49];

          ngNotify.set('Có lỗi xảy ra , xin vui lòng thử lại sau !', {
            position: 'top',
            type: 'error',
            duration: 3000
          });
          ++cov_13gx1dkt50.s[50];
          $mdDialog.hide();
        } else {
          ++cov_13gx1dkt50.b[2][1];
          ++cov_13gx1dkt50.s[51];

          ngNotify.set('Bạn đã tặng clip thành công', {
            position: 'top',
            type: 'success',
            duration: 3000
          });
          ++cov_13gx1dkt50.s[52];
          $mdDialog.hide();
        }
      });
    };
  }

  ++cov_13gx1dkt50.s[53];
  $scope.showPrompt = function (ev) {
    ++cov_13gx1dkt50.f[19];
    ++cov_13gx1dkt50.s[54];

    $mdDialog.show({
      controller: GiftController,
      templateUrl: 'app/views/prompt.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      escapeToClose: true,
      locals: {
        clipData: self.myScopeObject.clipData,
        msisdn: $scope.msisdn,
        receiver: $scope.receiver
      }
    }).then(function () {
      ++cov_13gx1dkt50.f[20];
    }, function () {
      ++cov_13gx1dkt50.f[21];
    });
    ++cov_13gx1dkt50.s[55];
    $scope.$watch(function () {
      ++cov_13gx1dkt50.f[22];
      ++cov_13gx1dkt50.s[56];

      return (++cov_13gx1dkt50.b[3][0], $mdMedia('xs')) || (++cov_13gx1dkt50.b[3][1], $mdMedia('sm'));
    }, function (wantsFullScreen) {
      ++cov_13gx1dkt50.f[23];
      ++cov_13gx1dkt50.s[57];

      $scope.customFullscreen = wantsFullScreen === true;
    });
  };
};

++cov_13gx1dkt50.s[58];


angular.module('app').component('views', {
  templateUrl: 'app/views/views.html',
  bindings: {
    clipData: '<'
  },
  controller: ViewsController
});